import { render, staticRenderFns } from "./OverviewCompanyBlock.vue?vue&type=template&id=7087315d&scoped=true&"
import script from "./OverviewCompanyBlock.vue?vue&type=script&lang=js&"
export * from "./OverviewCompanyBlock.vue?vue&type=script&lang=js&"
import style0 from "./OverviewCompanyBlock.vue?vue&type=style&index=0&id=7087315d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7087315d",
  null
  
)

export default component.exports